import { EventListeners, MinzeElement, Reactive, Attrs } from 'minze'
import { Locale } from '../../modules/locale'
import { Callback } from '../../modules/callback'
import { todayLocalIso } from '../base/date/date-utils'

Locale.getInstance().registerKeySet('fr', 'lvc-date-range-input-field', {
  startDateLabel: 'Date de début*',
  endDateLabel: 'Date de fin*',
  choose: 'Choisir',
})

Locale.getInstance().registerKeySet('en', 'lvc-date-range-input-field', {
  startDateLabel: 'Start date*',
  endDateLabel: 'End date*',
  choose: 'Choose',
})

export interface LvcDateRangeInputField {
  title: string
  placeholder: string
  open: boolean
  onChange: string
  defaultValue: any
  value: string
}

export class LvcDateRangeInputField extends MinzeElement {
  attrs: Attrs = ['title', 'placeholder', 'startDate', 'endDate', ['on-change', '']]

  reactive: Reactive = [
    ['background', 'transparent'],
    ['startDateValue', ''],
    ['endDateValue', ''],
  ]

  static observedAttributes = ['startDate', 'endDate']

  async onReady() {
    if (this.startDate && this.startDate !== true) this.startDateValue = this.startDate
    if (this.endDate && this.endDate !== true) this.endDateValue = this.endDate
  }

  html = () => {
    return `
      <lvc-box class="container" display="flex" justifyContent="flex-start">
        <div class="startDateContainer">
          <lvc-text class="title" font-preset="small">${Locale.getKey('lvc-date-range-input-field.startDateLabel')}</lvc-text>
          <lvc-datepicker
            preset='dropdown'
            name="startDate"
            value="${this.startDateValue}"
            default-value="${this.startDateValue}"
            min-date="${todayLocalIso()}"
            background='${this.background}'
            placeholder='${Locale.getKey('lvc-date-range-input-field.choose')}'
            placeholder-color='#1E007D'
            date-format-placeholder='false'
            position='below'
          ></lvc-datepicker>
        </div>
        <div class="endDateContainer">
          <lvc-text class="title" font-preset="small">${Locale.getKey('lvc-date-range-input-field.endDateLabel')}</lvc-text>
          <lvc-datepicker
            preset='dropdown'
            name="endDate"
            value="${this.endDateValue}"
            default-value="${this.endDateValue}"
            jump-to-date="${this.startDateValue}"
            min-date="${this.startDateValue}"
            background='${this.background}'
            placeholder='${Locale.getKey('lvc-date-range-input-field.choose')}'
            placeholder-color='#1E007D'
            date-format-placeholder='false'
            position='below'
          ></lvc-datepicker>
        </div>
      </lvc-box>
    `
  }

  css = () => {
    return `
      :host {
      }

      .container {
        gap: 16px;
      }

      .startDateContainer, .endDateContainer{
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
    `
  }

  eventListeners: EventListeners = [
    [
      '[name="startDate"]',
      'change',
      e => {
        const event = e as CustomEvent
        this.startDateValue = event.detail.value
        Callback.call(this.onChange as string, { startDate: event.detail.value })
      },
    ],
    [
      '[name="endDate"]',
      'change',
      e => {
        const event = e as CustomEvent
        this.endDateValue = event.detail.value
        Callback.call(this.onChange as string, { endDate: event.detail.value })
      },
    ],
  ]
}
